<h2 mat-dialog-title>{{ 'commonFolderInUseDialog.folderOnUse' | translate }}</h2>
<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <p>{{'commonFolderInUseDialog.firstMessage' | translate}}<br>
    {{'commonFolderInUseDialog.secondMessage' | translate}}</p>
</div>
<div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">{{ 'commonFolderInUseDialog.tryAgain' | translate }}</button>
    <button mat-button color="primary" [mat-dialog-close]="false">{{ 'commonFolderInUseDialog.cancel' | translate }}</button>
  </mat-dialog-actions>
</div>
